<script setup>

const route = useRoute();


</script>
<template>
    <YourAccount v-if="/^\/user\/account(\/.*)?$/.test(route.path)"></YourAccount>
    <Wallet v-if="/^\/user\/wallet(\/.*)?$/.test(route.path)"></Wallet>
    <Protection v-if="/^\/user\/protection(\/.*)?$/.test(route.path)" />
    <Promotion v-if="/^\/user\/promotion(\/.*)?$/.test(route.path)" />
</template>